import { SETTINGS_PAGE_URL } from '../../ApplicationWrapper.const';

export const NEW_SUB_ACCOUNT_URL = `${SETTINGS_PAGE_URL}{customerId}/product-environments?new=true`;

export const MIN_LENGTH_FOR_SEARCH_BAR = 3;
